import { render, staticRenderFns } from "./CardTransactions.vue?vue&type=template&id=3f31a35c&"
import script from "./CardTransactions.vue?vue&type=script&lang=js&"
export * from "./CardTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports